import { render, staticRenderFns } from "./course.vue?vue&type=template&id=7aca831a&scoped=true"
import script from "./course.vue?vue&type=script&lang=js"
export * from "./course.vue?vue&type=script&lang=js"
import style1 from "./course.vue?vue&type=style&index=1&id=7aca831a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aca831a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aca831a')) {
      api.createRecord('7aca831a', component.options)
    } else {
      api.reload('7aca831a', component.options)
    }
    module.hot.accept("./course.vue?vue&type=template&id=7aca831a&scoped=true", function () {
      api.rerender('7aca831a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/course/course.vue"
export default component.exports